module.exports = __webpack_public_path__ + "assets/34af599cc4f2e5ae924983c28d3fedf3.mp3";